<template>
  <div class="thanks">
    <h2>Obrigado</h2>
    <p>
      Seu cadastro foi realizado com sucesso!
    </p>
  </div>
</template>

<script>
export default {
  name: 'thanks',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-luna {
  color: #fff;
  background-color: #f26722;
  border-color: transparent;
  font-weight: bold;
  text-transform: uppercase;
}

.btn-luna:hover,
.btn-luna:focus,
.btn-luna:active {
  background-color: #d8518c;
}
</style>



// WEBPACK FOOTER //
// Thanks.vue?97de3392